import styled from 'styled-components';

export const BtnRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
